/**
 * MCS-150 biennial update schedule per 49 CFR 390.19(b).
 * Last digit of the USDOT number = month (1=Jan … 9=Sep, 0=Oct).
 * Next-to-last digit = year parity (odd → odd years, even → even years).
 * Deadline is the last day of that month.
 */

function lastDayOfMonthUtc(year, monthIndex) {
  return new Date(Date.UTC(year, monthIndex + 1, 0));
}

function parseDotDigits(dotNumber) {
  if (dotNumber == null) return undefined;
  const digits = String(dotNumber).trim();
  if (!/^\d{2,}$/.test(digits)) return undefined;
  return digits;
}

function monthIndexFromLastDigit(lastDigit) {
  return lastDigit === '0' ? 9 : Number(lastDigit) - 1;
}

function toValidDate(value) {
  if (value == null || value === '') return undefined;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isFinite(d.getTime()) ? d : undefined;
}

function yearMatchesParity(year, evenYears) {
  return year % 2 === 0 === evenYears;
}

/** Most recent deadline on or before `today`. */
function previousDeadline(today, monthIndex, evenYears) {
  let year = today.getUTCFullYear();
  if (!yearMatchesParity(year, evenYears)) year -= 1;
  let deadline = lastDayOfMonthUtc(year, monthIndex);
  if (deadline.getTime() > today.getTime()) {
    deadline = lastDayOfMonthUtc(year - 2, monthIndex);
  }
  return deadline;
}

/** Next deadline on or after `today`. */
function upcomingDeadline(today, monthIndex, evenYears) {
  let year = today.getUTCFullYear();
  if (!yearMatchesParity(year, evenYears)) year += 1;
  let deadline = lastDayOfMonthUtc(year, monthIndex);
  if (deadline.getTime() < today.getTime()) {
    deadline = lastDayOfMonthUtc(year + 2, monthIndex);
  }
  return deadline;
}

function addTwoYears(deadline, monthIndex) {
  return lastDayOfMonthUtc(deadline.getUTCFullYear() + 2, monthIndex);
}

function windowStart(deadline, monthIndex) {
  return lastDayOfMonthUtc(deadline.getUTCFullYear() - 1, monthIndex);
}

function isSatisfied(lastUpdate, deadline, monthIndex) {
  return lastUpdate.getTime() > windowStart(deadline, monthIndex).getTime();
}

export function computeMcs150NextDueDate(
  dotNumber,
  lastUpdate,
  today = new Date(),
) {
  const digits = parseDotDigits(dotNumber);
  if (!digits) return undefined;

  const monthIndex = monthIndexFromLastDigit(digits[digits.length - 1]);
  const evenYears = Number(digits[digits.length - 2]) % 2 === 0;
  const filed = toValidDate(lastUpdate);

  if (!filed) {
    return upcomingDeadline(today, monthIndex, evenYears);
  }

  const dPrev = previousDeadline(today, monthIndex, evenYears);
  if (!isSatisfied(filed, dPrev, monthIndex)) {
    return dPrev;
  }

  let due = addTwoYears(dPrev, monthIndex);
  let guard = 0;
  while (isSatisfied(filed, due, monthIndex) && guard < 100) {
    due = addTwoYears(due, monthIndex);
    guard += 1;
  }
  return due;
}
